<head>
	<!-- KaTeX -->
	<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.16.0/dist/katex.min.css" integrity="sha384-Xi8rHCmBmhbuyyhbI88391ZKP2dmfnOl4rT9ZfRI7mLTdk1wblIUnrIq35nqwEvC"
	 crossorigin="anonymous">
	<script defer src="https://cdn.jsdelivr.net/npm/katex@0.16.0/dist/katex.min.js" integrity="sha384-X/XCfMm41VSsqRNQgDerQczD69XqmjOOOwYQvr/uuC+j4OPoNhVgjdGFwhvN02Ja"
	 crossorigin="anonymous"></script>

</head>

<script>
  import { ReadingsStore } from '../stores.js';

  export let Index;
  export let steps = [];

  function katexRender(text) {
    return katex.renderToString(text)
  }

  // $: {
  //   console.log(steps)
  // }

</script>

<!-- The button to open modal -->
<label for={`my-modal-${Index}`} class="btn modal-button">View Steps</label>

<!-- Put this part before </body> tag -->
<input type="checkbox" id={`my-modal-${Index}`} class="modal-toggle" />
<label for={`my-modal-${Index}`} class="modal cursor-pointer">
  <label class="modal-box relative" for="">
    <label for={`my-modal-${Index}`} class="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
    <h3 class="text-lg font-bold">Steps</h3>
    <ul style="list-style-type: square;" class="px-4">
      {#each steps as step}
        <li class="py-3 break-normal">{@html katexRender(step)}</li>
      {/each}
    </ul>
  </label>
</label>